export var centerAlign = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

if (typeof centerAlign !== 'undefined' && centerAlign && centerAlign === Object(centerAlign) && Object.isExtensible(centerAlign) && !centerAlign.hasOwnProperty('__filemeta')) {
  Object.defineProperty(centerAlign, '__filemeta', {
    configurable: true,
    value: {
      name: "centerAlign",
      filename: "../node_modules/gatsby-theme-docz/src/utils/mixins.js"
    }
  });
}

export var ghostButton = {
  p: 0,
  outline: 'none',
  background: 'transparent',
  border: 'none',
  ':hover': {
    cursor: 'pointer'
  }
};

if (typeof ghostButton !== 'undefined' && ghostButton && ghostButton === Object(ghostButton) && Object.isExtensible(ghostButton) && !ghostButton.hasOwnProperty('__filemeta')) {
  Object.defineProperty(ghostButton, '__filemeta', {
    configurable: true,
    value: {
      name: "ghostButton",
      filename: "../node_modules/gatsby-theme-docz/src/utils/mixins.js"
    }
  });
}